import { createSelector } from '@ngrx/store';

import type { EntityState } from '@core/ngrx-legacy';
import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { ReportDetailsData, ReportDetailsFragment } from '@core/reports-types';

import { reportsStoreFeatureName } from '../consts';
import { safeReportsStateSelector } from '../helpers/safe-selector';

export type ReportsDetailsStoredValue = {
  key: string;
  details: unknown[];
  meta: {
    skippedCount: number;
    totalCount: number;
    details: string;
    settings?: Record<string, unknown>;
    [key: string]: unknown;
  };
};

const selectDetailsByKey = (details: ReportsDetailsStoredValue) => details.key;

const { actions, reducer, namespace, selectors, initialState } =
  createEntityCollectionStore<ReportsDetailsStoredValue>()('ReportsDetails', {
    baseSelector: (root): EntityState<ReportsDetailsStoredValue> =>
      safeReportsStateSelector(root, namespace, initialState, reportsStoreFeatureName),
    idSelector: selectDetailsByKey,
    customActions: adapter => ({
      resetAll: state => adapter.resetAll(state),
      fetchDetails: (
        state,
        {
          key,
        }: {
          data: ReportDetailsData;
          fragment: ReportDetailsFragment;
          page: number;
          key: string;
        },
      ) =>
        adapter.markAsPending(state, {
          scope: null,
          entities: [key],
        }),
    }),
  });

export const selectDetails = (key: string) =>
  createSelector(selectors.entityMap, entities => entities[key]);

export const selectDetailsMeta = (key: string) =>
  createSelector(selectors.entityMetaMap, entities => entities[key]!);

export const ReportsDetailsSelectors = {
  selectDetails,
  selectDetailsMeta,
};

export {
  actions as ReportsDetailsActions,
  namespace as ReportsDetailsNamespace,
  reducer as ReportsDetailsReducer,
};
